<template lang="pug">
#custom-button
  span(v-if="customButton.isLink")
    a(
      target="_blank"
      :href="customButton.customPageLink"
    )
      WtSvgIcon.has-margin-right-1(
        v-if="customButton.customButtonStyle === 'button'"
        icon="my-dashboard"
        width="20px"
        height="20px"
      )
  BMenuItem(
    v-else
    key="custom-route"
    tag="router-link"
    to="/info"
  )
    template(slot="label")
      WtSvgIcon.has-margin-right-1(
        v-if="customButton.customButtonStyle === 'button'"
        icon="my-dashboard"
        width="20px"
        height="20px"
      )
</template>

<script>
import { mapGetters } from "vuex";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";

export default {
  name: "CustomButton",

  components: {
    WtSvgIcon
  },

  data() {
    return {
      open: true,
      reduce: false
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),

    customButton() {
      return {
        isLink:
          this._.get(this.coreProgramMeta, "customButtonDestination", null) ===
          "externalLink",
        customButtonImage: this._.get(
          this.coreProgramMeta,
          "customButtonImage",
          null
        ),
        customButtonStyle: this._.get(
          this.coreProgramMeta,
          "customButtonStyle",
          null
        ),
        customButtonText: this._.get(
          this.coreProgramMeta,
          "customButtonText",
          null
        ),
        customPageLink: this._.get(this.coreProgramMeta, "customPageLink", null)
      };
    }
  }
};
</script>

<style lang="sass">
#custom-button
  list-style: none
</style>
